import { render, staticRenderFns } from "./create-email-modal.vue?vue&type=template&id=de0968f0"
import script from "./create-email-modal.vue?vue&type=script&lang=js"
export * from "./create-email-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports